import styled from 'styled-components';
import StatusIndicator from '../../reassignment/components/StatusIndicator';
import AsyncUIAvatar from '../../reassignment/components/AsyncUIAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AvatarWrapper = styled.div.withConfig({
  displayName: "AgentAvatar__AvatarWrapper",
  componentId: "zjk7m4-0"
})(["inline-size:32px;opacity:", ";position:relative;"], props => props.disabled ? 0.5 : 1);
const AgentAvatar = ({
  avatar,
  away = false,
  disabled = false,
  onClick,
  showStatus = false,
  size = 'sm'
}) => {
  return (
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsxs(AvatarWrapper, {
      "data-test-id": "agent-avatar",
      onClick: onClick,
      disabled: disabled,
      children: [/*#__PURE__*/_jsx(AsyncUIAvatar, {
        size: size,
        src: avatar || undefined,
        type: "contact"
      }), showStatus && /*#__PURE__*/_jsx(StatusIndicator, {
        away: away
      })]
    })
  );
};
AgentAvatar.displayName = 'AgentAvatar';
export default AgentAvatar;